import React, { FC, ReactNode } from 'react';
import Popup from 'app/components/entityDetailLayout/Popup';
import { ActivityIndicator } from '@kontentino/ui';
import clsx from 'clsx';

type Props = {
  header?: ReactNode | ReactNode[];
  footer?: ReactNode | ReactNode[];
  contentLeft?: ReactNode | ReactNode[];
  contentRight?: ReactNode | ReactNode[];
  popup?: {
    isActive: boolean;
    onHide: () => void;
    children: ReactNode | ReactNode[];
  };
  isLoading?: boolean;
  className?: string;
};

const EntityDetailLayout: FC<Props> = ({
  header,
  contentLeft,
  contentRight,
  footer,
  popup,
  isLoading,
  className,
}) => {
  return (
    <div
      className={clsx(
        'tw-relative tw-flex tw-w-full tw-flex-1 tw-flex-col tw-overflow-hidden',
        className,
      )}
    >
      {header}
      {(contentLeft || contentRight) && (
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-6 tw-overflow-y-auto tw-pb-1 tw-pl-0 tw-pr-0 tw-pt-4 lg:tw-flex-row lg:tw-gap-0 lg:tw-overflow-hidden">
          <div className="tw-space-y-4 tw-pl-3 tw-pr-3 lg:tw-sticky lg:tw-top-0 lg:tw-basis-1/2 lg:tw-overflow-auto lg:tw-pl-6">
            {contentLeft}
          </div>
          <div
            className="tw-space-y-2 tw-pl-3 tw-pr-3 lg:tw-basis-1/2 lg:tw-overflow-auto lg:tw-pr-6"
            id="post-preview_content-right"
          >
            {contentRight}
          </div>
        </div>
      )}
      {footer}
      {popup && (
        <>
          <div
            className="tw-transition-visibility tw-invisible tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-bg-grayscale-180 tw-bg-opacity-10 tw-opacity-0 tw-transition-opacity tw-duration-200 tw-ease-in-out"
            data-active={popup.isActive ?? false}
            onClick={popup.onHide}
          />
          <Popup isActive={popup.isActive ?? false} onHide={popup.onHide}>
            {popup.children}
          </Popup>
        </>
      )}
      {isLoading && (
        <div className="tw-absolute tw-left-0 tw-top-0 tw-z-10 tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-bg-[rgba(0,0,0,0.2)]">
          <ActivityIndicator className="tw-h-8 tw-w-8" />
        </div>
      )}
    </div>
  );
};

export default EntityDetailLayout;
